export default "__VITE_ASSET__0d3eab17__"